import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../api'

export const useAuthStore = defineStore('auth', () => {
  const isAuthenticated = ref(false)
  const user = ref(null)
  const loading = ref(false)

  // 统一清除认证信息的辅助函数
  const clearAuth = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    isAuthenticated.value = false
    user.value = null
  }

  // 检查认证状态
  const checkAuth = async () => {
    // 1. 优先检查本地是否有 token，如果没有直接返回未认证
    const token = localStorage.getItem('access_token') || localStorage.getItem('token')
    if (!token) {
      clearAuth()
      return
    }

    try {
      loading.value = true
      console.log('检查认证状态...')
      const response = await api.auth.check()
      console.log('认证响应:', response.data)
      
      // 兼容不同的响应数据结构
      const data = response.data.data || response.data
      const isAuth = data.authenticated || data.is_authenticated || response.data.authenticated
      
      if (isAuth) {
        isAuthenticated.value = true
        user.value = data.user || response.data.user || user.value
        console.log('用户已认证:', user.value)
      } else {
        // 后端明确返回未认证，清除本地残留 token
        clearAuth()
        console.log('用户未认证')
      }
    } catch (error) {
      console.error('检查认证状态失败:', error)
      // 如果是 401 或未授权，清除本地 token
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        clearAuth()
      } else {
        // 网络错误等其他情况，视为未认证
        clearAuth()
      }
    } finally {
      loading.value = false
    }
  }

  // 登录
  const login = async (username, password) => {
    try {
      loading.value = true
      const response = await api.auth.login(username, password)
      console.log('登录响应:', response.data)
      
      if (response.data.success) {
        if (response.data.data && response.data.data.access_token) {
          localStorage.setItem('access_token', response.data.data.access_token)
          localStorage.setItem('token', response.data.data.access_token)
          localStorage.setItem('refresh_token', response.data.data.refresh_token)
          console.log('Token 已保存')
        }
        
        isAuthenticated.value = true
        user.value = response.data.user
        return { success: true }
      } else {
        return { success: false, message: response.data.message }
      }
    } catch (error) {
      console.error('登录失败:', error)
      return { success: false, message: '网络错误，请稍后重试' }
    } finally {
      loading.value = false
    }
  }

  // 登出
  const logout = async () => {
    try {
      await api.auth.logout()
    } catch (error) {
      console.error('登出失败:', error)
    } finally {
      clearAuth()
    }
  }

  // 仅清除本地登录状态（不发请求）。
  // 用于改密码后强制重登：后端改密码时已撤销当前 token，再调 /auth/logout 会 401 触发拦截器跳转
  const logoutLocal = () => {
    clearAuth()
  }

  return {
    isAuthenticated,
    user,
    loading,
    checkAuth,
    login,
    logout,
    logoutLocal
  }
})